/*ěščřžýáíéúů*/
(function ($) {
	const $mainSelect = $('.doc-filter__select--main');
	const $subSelects = $('.doc-filter__select--sub');
	const $tables     = $('.doc-table');

	function showSubSelect( mainSlug ) {
		$subSelects.hide();
		$subSelects.filter('[name="' + mainSlug + '"]').show();
	}

	function showTable( subSlug ) {
		$tables.hide();
		$tables.filter('.' + subSlug).show();
	}

	// Init — show first matching sub-select and table
	const initMain = $mainSelect.val();
	showSubSelect( initMain );

	const initSub = $subSelects.filter('[name="' + initMain + '"]').val();
	if ( initSub ) {
		showTable( initSub );
	}

	// Main select change
	$mainSelect.on('change', function () {
		const mainSlug = $(this).val();
		showSubSelect( mainSlug );
		const subSlug = $subSelects.filter('[name="' + mainSlug + '"]:visible').val();
		showTable( subSlug );
	});

	// Sub select change
	$subSelects.on('change', function () {
		showTable( $(this).val() );
	});

})(jQuery);
